import { ZollAPIService } from '../../../services/zollApi.service'
import { zollBaseURL } from '../../../services/api.service'
import { ZollApiResponse } from '../../zollApi/store/zollApi.types'

const backupPcrUrl = `${zollBaseURL}/api/Pcr/backup-pcr`

export interface IBackupPcrRequestOptions {
  forceSnapshot: boolean
  debugLogging: boolean
}

export interface IBackupPcrRequest {
  pcrContent: string
  options?: IBackupPcrRequestOptions
}

export interface IBackupPcrResponseObject {
  message: string
  s3Key: string
  backupLogId: number
  latestVersion: number
  isSnapshot: boolean
  skipped: boolean
}

export interface IBackupPcrResponse extends ZollApiResponse {
  data?: IBackupPcrResponseObject
}

export class PcrBackupApiService extends ZollAPIService {
  async backupPcr(request: IBackupPcrRequest): Promise<IBackupPcrResponse> {
    return this.postWithError(backupPcrUrl, request)
  }
}
